/**
 * KpisRow — bandeau 4 KPIs (S6 PR5).
 *
 * Réutilise la primitive `<KPI>` existante (composants/ui/KPI.tsx).
 * Variant `accent` (rouge éditorial) sur Ventes pour appuyer le chiffre
 * business-critical.
 */

import KPI from '@/components/ui/KPI'
import { useDashboardKpis } from '@/hooks/useDashboard'

import './KpisRow.css'

function formatCents(cents: number): string {
  return (cents / 100).toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  })
}

export default function KpisRow() {
  const query = useDashboardKpis()

  if (query.isLoading) {
    return (
      <section className="kpis-row" aria-busy="true">
        <p className="ui-body ui-text-muted">Chargement des indicateurs…</p>
      </section>
    )
  }

  if (query.isError || !query.data) {
    return (
      <section className="kpis-row">
        <p className="ui-body ui-text-muted">Indicateurs indisponibles.</p>
      </section>
    )
  }

  const data = query.data

  return (
    <section className="kpis-row" aria-label="Indicateurs clés">
      <KPI
        label="Ventes 30j"
        value={data.sales_30d.toLocaleString('fr-FR')}
        legend={formatCents(data.sales_revenue_30d_cents)}
        variant="accent"
      />
      <KPI
        label="Publications actives"
        value={data.listings_active.toLocaleString('fr-FR')}
        legend="toutes plateformes"
      />
      <KPI
        label="File de publication"
        value={data.queue_size.toLocaleString('fr-FR')}
        legend="jobs en attente"
      />
      <KPI
        label="Favoris cumulés"
        value={data.favorites_total_active.toLocaleString('fr-FR')}
        legend="sur publications actives"
      />
    </section>
  )
}
